import React from "react";

import useMedia, { NOT_DESKTOP_QUERY } from "@app/util/hook/useMedia";

import Map from "./Map";
import MiniCalendar from "./MiniCalendar";
import styles from "./Sidebar.module.scss";
import Toolbar from "./Toolbar";
import UserFilter from "./UserFilter";

interface Props {}

const Sidebar: React.FC<Props> = () => {
  const isSmallScreen = useMedia(NOT_DESKTOP_QUERY);

  return (
    <div className={styles.container}>
      {!isSmallScreen && <Toolbar />}
      <MiniCalendar className={styles.calendar} />
      <UserFilter />
      <Map className={styles.map} />
    </div>
  );
};

export default Sidebar;
